(function(){

    angular.module('tmx-app').controller('loanProductCtrl', ['$scope','$state','LoanProductService','tmxUtility',
        '$mdSidenav','resolvedData','ServerExceptionService','menu',
        function LoanProductManagementCtrl($scope, $state,LoanProductService,tmxUtility,$mdSidenav, resolvedData,
            ServerExceptionService,menu){
            var loanProductManagementVM = this;
            loanProductManagementVM.EntityName = "Product";
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            loanProductManagementVM.isPageLoading = false;
        ///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            loanProductManagementVM.menu = menu;
            loanProductManagementVM.Privileges = [];
            loanProductManagementVM.ViewPrivilege = false;
            loanProductManagementVM.EditPrivilege = false;
            loanProductManagementVM.DeletePrivilege = false;
            loanProductManagementVM.AddPrivilege = false;
            loanProductManagementVM.checkPermission = tmxUtility.checkPermission;


            loanProductManagementVM.editPermission = loanProductManagementVM.checkPermission('Private.Transaction.LoanProduct','Edit');                    

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            loanProductManagementVM.dataLoading = true;
            loanProductManagementVM.gridData = {  data: new kendo.data.ObservableArray([])};
            loanProductManagementVM.date = new Date().toJSON(); //used in isStatusActive()
//////////////////////SEARCH SIDE NAV VARIABLE INITILAIZATIONS//////////////////////////////////////////////////////////
            loanProductManagementVM.nav = "SearchSideNav";
            loanProductManagementVM.searchSideNavActive = false;
            loanProductManagementVM.exportSideNavActive = false;
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
 ///////////  WATCHING FOR CHANGES IN THE ERROR in  RESPONSE IN Viewing GRID ///////////////////////////////////////
            $scope.$watch(function () { return ServerExceptionService.Displaymsg}, function (newVal, oldVal) {
                if($scope.watch_count > 1) {
                    return;
                }

                if (typeof newVal !== 'undefined' && $scope.watch_count == 1) {
                    $scope.error = ServerExceptionService.Displaymsg;
                    loanProductManagementVM.dataLoading = false; // remove the loading imaging when error is displayed
                    $scope.watch_count = $scope.watch_count+1;
                    ServerExceptionService.Displaymsg = oldVal;//to differentiate old value from new value when user signs
                // in multiple time using incorrect username and password and the server returns the same error
                    $scope.$on("$destroy", function(){
                        ServerExceptionService.Displaymsg = "";
                    });
                }
            });
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////*******************KENDO START*********************//////////////////////////////////

            loanProductManagementVM.gridColumns = LoanProductService.columns;
            loanProductManagementVM.filterColumns = LoanProductService.filterColumn;

////////////////////////////////////////////////BUILDING THE GRID///////////////////////////////////////////////////////
            loanProductManagementVM.mainGridOptions = {
                dataSource: {

                //data: loanProductManagementVM.gridData
                    transport: {
                        read: function(o){

                            if(angular.isDefined(loanProductManagementVM.searchClear) && loanProductManagementVM.searchClear==false){
                                if(exists(loanProductManagementVM.o)){
                                    copy(loanProductManagementVM.o.data,["filter"],o.data);
                                }
                            }
                            loanProductManagementVM.searchClear = false;
                            if(loanProductManagementVM.onChildState()){return;}

                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    loanProductManagementVM.searchClear = true;
                                    $state.searchClear=undefined;
                                //return;
                                }
                            //if(exists(companyVM.o)){
                            //copy(companyVM.o.data,["filter"],o.data);
                            //}
                            }
                            else{
                                o.data.firstPage = true;
                            }
                        //if(loanProductManagementVM.o.data.filter == undefined){
                        //    //clear search text as well in side nav
                        //    loanProductManagementVM.searchClear = true;
                        //}
                        //else{
                        //    loanProductManagementVM.searchClear = false;
                        //}
                            loanProductManagementVM.o = angular.copy(o);
                            loanProductManagementVM.filters = loanProductManagementVM.o.data.filter;
                            loanProductManagementVM.isPageLoading = true;
                            LoanProductService.getByParams(o,true).then(function(response){
                                parseResppnse(response.data);
                                loanProductManagementVM.dataLoading = false;
                                loanProductManagementVM.excelData=response;
                                o.success(response);//full response returned
                                loanProductManagementVM.isPageLoading = false;
                            },
                            function(){ //in case of error loading data
                                $scope.watch_count = 1;
                            });
                        },
                        dataType: "application/json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },

                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort:  [{field: "Status", dir: "asc"}]
                },
                excelExport: function(e) {                                         
                    var sheet = e.workbook.sheets[0];
                    var data = loanProductManagementVM.excelData.data;
                    var gridColumns = loanProductManagementVM.container.productGrid.columns;                    
                    var columns = tmxUtility.columnsMapping(gridColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);                    
                    sheet.rows = rows;
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "LoanProduct.pdf"
                },
                excel: {
               /* allPages: true,*/
                    fileName: "LoanProduct.xlsx"
                },

                sortable: true,
                scrollable: false,
                columns:  LoanProductService.columns
            };
    //////////INITIALIZING THE $state.data for access to grid in Edit.js///////////////////////////////////////////////
            loanProductManagementVM.container = {};//defining the object for grid access in controller
            $state.data= {
                grid: loanProductManagementVM.container,
                mainGridOptions: angular.copy(loanProductManagementVM.mainGridOptions)
            };

///////////////////////////////////*******************KENDO END*********************////////////////////////////////////

/////////////////////////////////////*************Functions START****************///////////////////////////////////////
/////////////////////////////////////////CHECK IF ON CHILD STATE (ADD/EDIT)/////////////////////////////////////////////
            loanProductManagementVM.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            };
///////////////////////////////////////////////GO TO VIEW CHILD STATE///////////////////////////////////////////////////
            loanProductManagementVM.clickView = function (item) {
            //$state.data.info = false;
                $state.go($state.current.name+".edit",{"Id":item.ProductId});
            };
 ///////////////////////////////**********kendo row template functions************//////////////////////////////////////
 //////////////////////////MAIN GRID Product Code row template display function///////////////////////////////////////
            loanProductManagementVM.getProductCode=function(dataitem) {
                return dataitem.ProductCode;
            };
//////////////////////////MAIN GRID LoanProductName row template display function///////////////////////////////////////
            loanProductManagementVM.formatProductName=function(dataitem) {
                return tmxUtility.sliceText(dataitem,40);
            };
            
//////////////////////GET PRODUCT TYPE  in rowTemplate display/////////////////////////////////////////////////////////
            loanProductManagementVM.getProductType=function(dataitem) {
                loanProductManagementVM.receivedProductTypes = LoanProductService.receivedProductTypes;
                if(angular.isDefined(LoanProductService.lookup.types) && LoanProductService.lookup.types.length>0) {
                    for (var i = LoanProductService.lookup.types.length - 1; i >= 0; i--) {
                        if(LoanProductService.lookup.types[i].LookupId == dataitem.ProductTypeLkp) {

                            return LoanProductService.lookup.types[i].VisibleValue;
                        }
                    }
                }
            //return "N/A";
                return dataitem.ProductTypeLkp;

            };
//////////////////////GET PRODUCT FREQUENCY  in rowTemplate //in display////////////////////////////////////////////////
            loanProductManagementVM.getProductFrequency=function(dataitem) {
                loanProductManagementVM.receivedFreq = LoanProductService.recievedFreq;
                if(angular.isDefined(LoanProductService.lookup.repaymentFreq) && LoanProductService.lookup.repaymentFreq.length>0) {
                    for (var i = LoanProductService.lookup.repaymentFreq.length - 1; i >= 0; i--) {
                        if(LoanProductService.lookup.repaymentFreq[i].LookupId == dataitem.RepaymentFrequencyLkp) {
                            return LoanProductService.lookup.repaymentFreq[i].VisibleValue;
                        }
                    }
                }
                return "N/A";
            //if(dataitem.RepaymentFrequencyLkp == null ){
            //    return dataitem.RepaymentFrequencyLkp = "none";
            //}
            //else{
            //    return dataitem.RepaymentFrequencyLkp;
            //}

            };
/////////////////////////////GET PRODUCTSTATUS ACCORDING TO EFFECTIVE END AND START DATE/////////////////////////////
            loanProductManagementVM.getStatus = function(dataitem) {
             
                return dataitem.Status;
            //var currentDate = new Date();
            //var startDate = kendo.parseDate(dataitem.EffectiveStartDate);
            //var endDate = kendo.parseDate(dataitem.EffectiveEndDate);
            //if (((endDate - currentDate) >= 0) && ((startDate - currentDate) <= 0))
            //    return 'Active';
            //else
            //    return 'Inactive';
            };
////////////////////////////////////////////////CHECK IF ROLE ACTIVE OR DEACTIVE///////////////////////////////////////
            loanProductManagementVM.isStatusActive = function(dataitem) {
             
                if (dataitem.Status == "Active")
                    return true;
                else
                    return false;
            };
//////////////FUNCTION to be called(NOT USED YET) from edit.js>save() to update grid after adding a role///////////////
            loanProductManagementVM.reload=function(){
                loanProductManagementVM.container.productGrid.dataSource.read();
            };

///////////////////////////////****************KENDO GRID FUNC END*******************//////////////////////////////////
//////////////MOBILE LIST GRIDDATA : GRID DATA not TRANSPORT///////////////////////////////////////////////
            for(var i=0; i<resolvedData.data.length; i++) {
            //pushing status to the resolvedData
                resolvedData.data[i].Status = loanProductManagementVM.getStatus(resolvedData.data[i]);
                loanProductManagementVM.gridData.data.push(resolvedData.data[i]);
            }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //////////////////////////SIDE NAV SEARCH ICON CLICK FUNCTION///////////////////////////////////////////////////////////
            loanProductManagementVM.toggleSearch = function() {

                if (loanProductManagementVM.searchSideNavActive) {
                    loanProductManagementVM.searchSideNavActive = false;
                }
                else{
                    loanProductManagementVM.searchSideNavActive = true;
                }
                loanProductManagementVM.toggle('SearchSideNav');
            };
//////////////////////////SIDE NAV EXPORT ICON CLICK FUNCTION///////////////////////////////////////////////////////////
            loanProductManagementVM.toggleExport = function() {

                if (loanProductManagementVM.exportSideNavActive)
                    loanProductManagementVM.exportSideNavActive = false;
                else{
                    loanProductManagementVM.exportSideNavActive = true;
                }
                loanProductManagementVM.toggle('ExportSideNav');
            };
/////////////////////////SIDE NAV SEARCH/EXPORT TOGGLE/////////////////////////////////////////////////////////////////////////
            loanProductManagementVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function(){
                    });
            };
/////////////////////////SIDE NAV EXPORT/SEARCH MENU CHECK IF OPEN//////////////////////////////////////////////////////
            loanProductManagementVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };
//////////////////////FUNCTION TO BE FORWARDED FOR SEARCH SIDENAV CUSTOM BUILT DIRECTIVE///////////////////////////////
            loanProductManagementVM.success=function(promise){
                if(promise.read==true) {
                    loanProductManagementVM.container.productGrid.dataSource.transport.read(promise);
                }
                else {
                    loanProductManagementVM.container.productGrid.dataSource.read();
                }
                loanProductManagementVM.toggle(loanProductManagementVM.nav);
            };
/////////////////////TO DISPLAY THE FILTERED ICON AFTER SEARCH SIDE NAV IN COL HEADER KENDO/////////////////////////////
            loanProductManagementVM.isFiltered=function(fieldName){
             
                var filtered = false;
                if(fieldName=="Status"){
                    fieldName="EffectiveEndDate";
                }
                if(angular.isDefined(  loanProductManagementVM.filters)) {
                    loanProductManagementVM.filters.filters.forEach(function(filter){

                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            };

            loanProductManagementVM.getStatus = function (dataitem) {

                if (dataitem.Status == "Inactive") {
                    return "Inactive";
                }             
                else if (dataitem.Status == "Active") {
                    return "Active";
                }
            };

            loanProductManagementVM.formatDescription = function (dataitem) {
                if (!dataitem) return '';
                return dataitem;
            };

            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.ProductName = loanProductManagementVM.formatProductName(dataItem.ProductName);                    
                    dataItem.StatusBKColor= tmxUtility.SetStatusBackgroundColor(dataItem.Status);
                    dataItem.ProductDescription = loanProductManagementVM.formatDescription(dataItem.ProductDescription);
                });
            }
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        }]);
})();